const $$splitComponentImporter = () => import('/opt/buildhome/repo/src/routes/pro/dashboard/booking-queue.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { Filter } from 'lucide-react';
export const Route = createFileRoute('/pro/dashboard/booking-queue')({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});
interface Booking {
  id: string;
  petId: string | null;
  petName: string;
  petSpecies: string | null;
  petBreed: string | null;
  ownerName: string;
  ownerEmail: string | null;
  ownerPhone: string | null;
  scheduledDate: string;
  scheduledTime: string;
  duration: number | null;
  serviceType: string | null;
  serviceName: string | null;
  serviceCategory: string | null;
  reason: string | null;
  notes: string | null;
  status: string;
  priority: string;
  source: string;
  isEmergency: boolean;
  assignedToMemberId: string | null;
  completedAt: string | null;
  createdAt: string;
}
interface Member {
  id: string;
  displayName: string | null;
  roleName: string;
  roleType: string;
  user: {
    fullName: string;
  } | null;
  status: string;
}